function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Callout, ConfirmationModal, FunctionalLoader, GridItem, Spinner, TextField, Typography, useStateInRef } from 'seagull';
import React, { useMemo, useRef, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { defaultAgreementTitle, howToEditAgreementUrl, routes } from "../../constants";
import { useEventReporter, useGlobalContext, useIoContext, useStore, useStoreActions } from "../../contexts";
import { handleRequest, sendErrReport, wait } from "../../infra/utils";
import { contactModel, timeModel } from "../../models";
import { AgreementName } from "./AgreementName";
import { contactHasAgreement, getCreateRelationshipError } from "./AgreementStudio.utils";
import AgreementStudioWithLegalTermsModal from "./AgreementStudioWithLegalTermsModal";
import { ClientPreview } from "../ClientPreview/ClientPreview";
import { useCopyProposalLink } from "../../hooks/useCopyProposalLink";
import { generateUniqueId } from 'seagull/utils/generateUniqueId';
import { makeNetTerms } from "../../infra/translator";
import { PostAgreementCreation } from "./PostAgreementCreation";
import { Checkmark, CloseLiner24, TrashLine } from 'seagull/icons';
import DatePickerPanel from "./DatePickerPanel";
import { Intent } from "../../infra/access-control";
import ContactDetails from "./ContactDetails/ContactDetails";
import ExternalLinkButton from "../ExternalLinkButton";
import styles from "./AgreementStudio.module.scss";
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
import AddAdditionalRecipients from "./AddAdditionalRecipients/AddAdditionalRecipients";
import { validateReviewers } from "../../business-logic/draftLogic";
import { useSignal } from "../../hooks/useSignal";
import { ErrorResponse, ServerError } from "../../infra/ErrorResponse";
import { makeDraft } from "./AgreementStudioProposalMode.utils";
import SignatoryCheckbox from "./SignatoryCheckbox/SignatoryCheckbox";
import ReadyToSendModal from "./ReadyToSendModal/ReadyToSendModal";
const createRelationshipLoader = 'createRelationship';
var DraftStatus = /*#__PURE__*/function (DraftStatus) {
  DraftStatus["Loading"] = "loading";
  DraftStatus["Saved"] = "saved";
  DraftStatus["Error"] = "error";
  DraftStatus["None"] = "none";
  return DraftStatus;
}(DraftStatus || {});
function getSavingStatusMP(draftStatus) {
  switch (draftStatus) {
    case DraftStatus.None:
      return null;
    case DraftStatus.Loading:
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Spinner, {
        size: 24
      }), /*#__PURE__*/React.createElement(Typography, {
        role: "alert",
        as: "p"
      }, "Saving draft"));
    case DraftStatus.Saved:
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: styles.checkmarkContainer
      }, /*#__PURE__*/React.createElement(Checkmark, null)), /*#__PURE__*/React.createElement(Typography, null, "Draft saved"));
    case DraftStatus.Error:
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: styles.savingError
      }, /*#__PURE__*/React.createElement(CloseLiner24, null)), /*#__PURE__*/React.createElement(Typography, null, "Draft save error"));
  }
}
export function AgreementStudioProposalMode(props) {
  var _props$relationshipDr, _ref, _relationshipDraft$is;
  const relationshipDraft = props.relationshipDraft;
  const {
    MULTIPLE_RECEPIENTS
  } = useFeatureFlags();
  const {
    reportFormSubmission,
    reportToAppcues,
    reportToGtm,
    reportToHubspot,
    reportToHeap
  } = useEventReporter();
  const history = useHistory();
  const {
    prepareFormObject,
    reportProductsFormSubmission,
    reportButtonClick
  } = useEventReporter();
  const {
    api,
    fetchContacts,
    setWorksAt,
    logBI
  } = useStoreActions();
  const globalContext = useGlobalContext();
  const legalTermsDocuments = useStore(state => state.legalTerms.data);
  const agreements = useStore(state => state.agreements.data);
  const proposals = useStore(state => state.proposals.data);
  const scrollToTopRef = useRef(null);
  const [newContactValid, setNewContactValid] = useState(true);
  const [firstName, setFirstName] = useState((relationshipDraft === null || relationshipDraft === void 0 ? void 0 : relationshipDraft.buyerFirstName) || '');
  const [lastName, setLastName] = useState((relationshipDraft === null || relationshipDraft === void 0 ? void 0 : relationshipDraft.buyerLastName) || '');
  const [companyName, setCompanyName] = useState((relationshipDraft === null || relationshipDraft === void 0 ? void 0 : relationshipDraft.customerName) || '');
  const [email, setEmail] = useState((relationshipDraft === null || relationshipDraft === void 0 ? void 0 : relationshipDraft.buyerEmail) || '');
  const [phone, setPhoneNumber] = useState((relationshipDraft === null || relationshipDraft === void 0 ? void 0 : relationshipDraft.buyerPhone) || null);
  const [titleValid, setTitleValid] = useState(((_props$relationshipDr = props.relationshipDraft) === null || _props$relationshipDr === void 0 ? void 0 : _props$relationshipDr.title) != null);
  const [clientContactId, setClientContactId] = useState(relationshipDraft === null || relationshipDraft === void 0 ? void 0 : relationshipDraft.clientContactId);
  const [showAgreementTitleWarning, setShowAgreementTitleWarning] = useState(false);
  const locationState = useLocation().state;
  const [isSampleRelationship, setIsSampleRelationship] = useState((_ref = (_relationshipDraft$is = relationshipDraft === null || relationshipDraft === void 0 ? void 0 : relationshipDraft.isSample) !== null && _relationshipDraft$is !== void 0 ? _relationshipDraft$is : locationState === null || locationState === void 0 ? void 0 : locationState.defaultToSampleContact) !== null && _ref !== void 0 ? _ref : false);
  const [effectiveDate, setEffectiveDate] = useState(() => relationshipDraft !== null && relationshipDraft !== void 0 && relationshipDraft.effectiveDate ? timeModel.fromDatestampObject(relationshipDraft.effectiveDate) : null);
  const [showCustomerDetailsWarning, setShowCustomerDetailsWarning] = useState(false);
  const [draftId, setDraftId] = useState(relationshipDraft === null || relationshipDraft === void 0 ? void 0 : relationshipDraft.id);
  const getDraftId = useStateInRef(draftId);
  const [reviewers, setReviewers] = useState(relationshipDraft ? relationshipDraft.reviewers : []);
  const [showReviewerErrors, signalShowReviewerErrors] = useSignal();
  const {
    getNow
  } = useIoContext();
  const contacts = useStore(state => state.contacts);
  const [contactsMap, sampleContact] = useMemo(() => {
    var _contacts$data;
    const contactsData = (_contacts$data = contacts.data) !== null && _contacts$data !== void 0 ? _contacts$data : [];
    const contactsMap = {};
    let sampleContact = contactModel.makeSampleContact({
      createdAt: getNow(),
      vendorId: props.worksAt.id
    });
    for (let i = 0; i < contactsData.length; i++) {
      const contact = contactsData[i];
      if (contact.isSample) {
        sampleContact = contact;
      } else {
        contactsMap[contact.id] = contact;
      }
    }
    return [contactsMap, sampleContact];
  }, [contacts, props.worksAt.id]);
  const isSavingDraft = useRef(false);
  const [draftStatus, setDraftStatus] = useState(DraftStatus.None);
  const existingContact = clientContactId ? contactsMap[clientContactId] : isSampleRelationship ? sampleContact : undefined;
  const [agreementTitle, setAgreementTitle] = useState((relationshipDraft === null || relationshipDraft === void 0 ? void 0 : relationshipDraft.title) || defaultAgreementTitle);

  //the 'edit' is for backwards compatibility - changing the terminology. This could probably be deleted shortly
  const isDraftOriginatedAsEdit = !!relationshipDraft && ['withdraw-to-edit', 'edit'].includes(relationshipDraft.creationStrategy);
  const showAgreementCreationToast = () => globalContext.showSuccessToast('Agreement was sent successfully');
  const navigationAfterCreation = redirectUrl => {
    const url = redirectUrl || routes.proposalsDashboard;
    history.push(url);
    if (url === routes.agreementStudio) {
      history.go(0);
    }
  };
  const {
    getAgreementNotificationLink,
    getAgreementNotificationLinks
  } = useCopyProposalLink();
  const draftToCommonWithId = draft => ({
    id: generateUniqueId('proposal-template'),
    coverLetter: draft.coverLetter,
    extraClause: draft.extraClause,
    requirePaymentMethod: draft.requirePaymentMethod,
    allowManualPayments: draft.allowManualPayments,
    isExistingCustomer: draft.isExistingCustomer,
    customNotificationText: draft.customNotificationText,
    services: draft.services,
    serviceBundles: draft.serviceBundles,
    netTerms: draft.netTerms,
    legalTerms: draft.legalTerms,
    coverCreditCardFees: draft.feeControls.coverCreditCardFees,
    /** Will automatic ongoing services be billed at the start or end of the billing-period. */
    amendmentsApprovalMethod: draft.amendmentsApprovalMethod,
    invoicesApprovalMethod: draft.invoicesApprovalMethod,
    requestAccountantAccess: draft.requestAccountantAccess,
    introVideo: draft.introVideo
  });
  const discardDraft = async () => {
    const loaderName = 'discardDraft';
    globalContext.startLoader(loaderName);
    try {
      await api.draft.deleteById(draftId);
      history.push(routes.draftsDashboard);
    } finally {
      globalContext.stopLoader(loaderName);
    }
  };
  const genDraftId = () => {
    if (draftId) {
      return draftId;
    } else {
      const id = generateUniqueId('draft');
      setDraftId(id);
      window.history.replaceState('', 'Draft', routes.draft(id));
      return id;
    }
  };
  const saveDraft = async (data, isMounted) => {
    var _data$legalTerms;
    reportFormSubmission('agreement-studio-mandatory-fields', [prepareFormObject('agreement-studio-mandatory-fields-first-name', firstName), prepareFormObject('agreement-studio-mandatory-fields-last-name', lastName), prepareFormObject('agreement-studio-mandatory-fields-company-name', companyName), prepareFormObject('agreement-studio-mandatory-fields-email-address', email)]);
    if (!isMounted()) return;
    isSavingDraft.current = true;
    setDraftStatus(DraftStatus.Loading);
    const invalidLegalTerms = ((_data$legalTerms = data.legalTerms) === null || _data$legalTerms === void 0 ? void 0 : _data$legalTerms.type) === 'pdf' && !data.legalTerms.pdfUniqueName;
    if (invalidLegalTerms) return;
    const draftToSave = makeDraft(_objectSpread(_objectSpread({}, data), {}, {
      id: genDraftId(),
      title: agreementTitle,
      buyerFirstName: firstName,
      buyerLastName: lastName,
      buyerEmail: email,
      buyerPhone: phone,
      customerName: companyName,
      clientContactId,
      isSample: isSampleRelationship,
      effectiveDate,
      reviewers
    }));
    const result = await handleRequest(api.draft.save(draftToSave));
    if (!isMounted()) return;
    isSavingDraft.current = false;
    setDraftStatus(result.success ? DraftStatus.Saved : DraftStatus.Error);
  };
  const onSubmit = async data => {
    var _props$worksAt$key;
    reportButtonClick('agreement-studio-topbar-btn-submit');
    logBI(10485);
    let finalFirstName = firstName;
    let finalLastName = lastName;
    let finalCompanyName = companyName;
    let finalEmail = email;
    if (clientContactId && existingContact) {
      finalFirstName = existingContact.firstName;
      finalLastName = existingContact.lastName;
      finalCompanyName = existingContact.companyName;
      finalEmail = existingContact.email;
    }
    if (isSampleRelationship) {
      finalFirstName = sampleContact.firstName;
      finalLastName = sampleContact.lastName;
      finalCompanyName = sampleContact.companyName;
      finalEmail = sampleContact.email;
    }

    // First things first: validate stuff!
    if (!newContactValid || !finalFirstName || finalFirstName.length < 2 || !finalLastName || finalLastName.length < 2 || !finalCompanyName) {
      if (scrollToTopRef.current != null) scrollToTopRef.current();
      setShowCustomerDetailsWarning(true);
      return;
    }
    if (!validateReviewers(reviewers, existingContact)) {
      signalShowReviewerErrors(true);
      return;
    }
    if (!titleValid) {
      setShowAgreementTitleWarning(true);
      return;
    }
    const shouldSendAgreement = await globalContext.showModal({
      closeOnClickOutside: true,
      closeOnEscapeKey: true,
      content: _ref2 => {
        let {
          dismissModal
        } = _ref2;
        return /*#__PURE__*/React.createElement(ReadyToSendModal, {
          firstName: finalFirstName,
          lastName: finalLastName,
          companyName: finalCompanyName,
          email: finalEmail,
          reviewers: reviewers,
          dismissModal: dismissModal
        });
      }
    });
    if (!shouldSendAgreement) return;
    if (isSampleRelationship) {
      logBI(11901);
      reportToGtm('form-success', 'vendor-sent-test-agreement');
      reportToAppcues('form-success', 'vendor-sent-test-agreement');
      reportToHeap('testAgreement', 'submit', 'vendor-sent-test-agreement');
      reportToHubspot('vendor_sent_a_test_agreement');
    } else {
      logBI(10479, {
        clientEmail: finalEmail,
        selectedDay: undefined
      });
      reportProductsFormSubmission('send-agreement-for-approval', [prepareFormObject('buyerName', {
        first: finalFirstName,
        last: finalLastName
      }), prepareFormObject('buyerEmail', finalEmail), prepareFormObject('customerName', finalCompanyName), prepareFormObject('serviceCount', data.services.length), prepareFormObject('netTerms', makeNetTerms(data.netTerms)), prepareFormObject('isExistingCustomer', data.isExistingCustomer)]);
    }
    globalContext.startLoader(createRelationshipLoader);

    // To avoid a race-condition, don't allow to create a relationship while we're saving a draft
    while (isSavingDraft.current) {
      await wait(300);
    }
    const result = await handleRequest(api.relationship.createFromDraft(getDraftId()));
    if (!result.success) {
      const {
        text
      } = getCreateRelationshipError(result.error);
      globalContext.showErrorToast(text);
      saveDraft(data, () => true);
      globalContext.stopLoader(createRelationshipLoader);
      return;
    }
    const key = isSampleRelationship ? 'numSampleAgreements' : 'numSaleAgreements';
    const {
      pending,
      approved
    } = (_props$worksAt$key = props.worksAt[key]) !== null && _props$worksAt$key !== void 0 ? _props$worksAt$key : {
      pending: 0,
      approved: 0
    };
    setWorksAt(_objectSpread(_objectSpread({}, props.worksAt), {}, {
      [key]: {
        pending: pending + 1,
        approved
      }
    }));
    if (!isSampleRelationship && pending === 0 && approved === 0) {
      // Important note: this event should be sent from the backend, as we can't assure that the "worksAt" is correct.
      // It is a technical gap.
      reportToGtm('form-success', 'user-successfully-sent-first-agreement');
      reportToAppcues('form-success', 'user-successfully-sent-first-agreement');
      reportToHubspot('user_successfully_sent_first_agreement_');
      reportToHeap('agreementStudio', 'submit', 'user-successfully-sent-first-agreement');
    }
    globalContext.stopLoader(createRelationshipLoader);
    try {
      const notification = await (MULTIPLE_RECEPIENTS ? getAgreementNotificationLinks : getAgreementNotificationLink)(result.data);
      const redirectUrl = await globalContext.showModal({
        closeOnClickOutside: true,
        closeOnEscapeKey: true,
        content: _ref3 => {
          let {
            dismissModal
          } = _ref3;
          const key = MULTIPLE_RECEPIENTS ? 'recipients' : 'linkUrl';
          const postAgreementCreationProps = {
            relationshipId: result.data,
            testId: 'agreement-studio-post-creation-modal',
            onClose: dismissModal,
            name: "".concat(finalFirstName, " ").concat(finalLastName),
            sampleAgreementData: isSampleRelationship ? {
              email: props.userEmail
            } : undefined,
            [key]: notification
          };
          return /*#__PURE__*/React.createElement(PostAgreementCreation, postAgreementCreationProps);
        }
      });
      navigationAfterCreation(redirectUrl);
    } catch (error) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      sendErrReport('failed to show success modal', error);
      showAgreementCreationToast(); //fail silently in a reasonable way
      navigationAfterCreation();
    }
  };
  const openPreviewModal = data => {
    reportButtonClick('agreement-previewed-agreement');
    if (!legalTermsDocuments) return;
    const draft = makeDraft(_objectSpread(_objectSpread({}, data), {}, {
      id: getDraftId() || '',
      title: agreementTitle,
      buyerFirstName: firstName,
      buyerLastName: lastName,
      buyerEmail: email,
      buyerPhone: phone,
      customerName: companyName,
      clientContactId,
      isSample: isSampleRelationship,
      effectiveDate,
      reviewers
    }));
    globalContext.showModal({
      closeOnClickOutside: true,
      closeOnEscapeKey: true,
      content: props => /*#__PURE__*/React.createElement(ClientPreview, _extends({
        type: "draft",
        draftInfo: {
          draft,
          sampleContact,
          contactsMap,
          legalTerms: legalTermsDocuments
        }
      }, props))
    });
  };
  const saveAsTemplate = async () => {
    if (draftId != null) {
      const name = await globalContext.showModal({
        content: function RenameModal(_ref4) {
          let {
            dismissModal
          } = _ref4;
          const [name, setName] = useState('');
          return /*#__PURE__*/React.createElement(ConfirmationModal, {
            title: "Save as template",
            "data-testid": "save-as-proposal-template-modal",
            content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextField, {
              testid: "proposal-template-name",
              name: "templateName",
              label: "Template name",
              value: name,
              onChange: e => {
                setName(e.target.value);
              },
              autoFocus: true
            }), /*#__PURE__*/React.createElement(Callout, {
              style: {
                marginTop: '32px'
              }
            }, "Your template can be managed and used through the \"Proposal Templates\" page.")),
            primaryButtonLabel: "Save",
            onPrimaryButtonClick: () => dismissModal(name),
            secondaryButtonLabel: "Cancel",
            onSecondaryButtonClick: () => dismissModal(null),
            onCloseButtonClick: () => dismissModal(null)
          });
        }
      });
      if (name) {
        api.proposalTemplates.createFromDraft(draftId, name).then(() => {
          history.push(routes.proposalTemplates);
        }).then(() => {
          globalContext.showSuccessToast('Proposal template successfully saved', 'proposal-template-saved-toast');
        }, e => {
          if (new ErrorResponse(e).hasServerError(ServerError.NameAlreadyExists)) {
            globalContext.showErrorToast('A template with this name already exists', 'proposal-template-name-already-used');
          } else {
            globalContext.showErrorToast('There was an error saving this template', 'proposal-template-not-saved-toast');
          }
        });
      }
    }
  };
  const amendmentInfoCallout = existingContact && contactHasAgreement(existingContact, agreements, proposals) && /*#__PURE__*/React.createElement(Callout, null, "It appears you have an agreement with ", existingContact.companyName, ". To change terms, or add/edit services, edit the existing agreement instead of creating a new one.", ' ', /*#__PURE__*/React.createElement(ExternalLinkButton, {
    openInNewTab: true,
    href: howToEditAgreementUrl,
    testid: "agreement-studio-amendment-info"
  }, "Learn more"));
  return legalTermsDocuments && contacts.data ? /*#__PURE__*/React.createElement(AgreementStudioWithLegalTermsModal, _extends({}, props, {
    relationshipDraft: props.relationshipDraft != null ? draftToCommonWithId(props.relationshipDraft) : undefined,
    isSampleRelationship: isSampleRelationship,
    modalTitle: "Create proposal",
    contact: existingContact,
    legalTermsDocuments: legalTermsDocuments,
    effectiveDate: effectiveDate,
    additionalAutoSaveDependencies: [agreementTitle, clientContactId, companyName, effectiveDate, email, firstName, lastName, phone, reviewers],
    doScrollToTopRef: scrollToTopRef,
    savingStatusMP: getSavingStatusMP(draftStatus),
    agreementTitleMP: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AgreementName, {
      agreementTitle: agreementTitle,
      setAgreementTitle: setAgreementTitle,
      setAgreementTitleValid: setTitleValid,
      showWarning: showAgreementTitleWarning,
      label: "Agreement name"
    }), /*#__PURE__*/React.createElement(ContactDetails, {
      newContact: {
        firstName,
        lastName,
        companyName,
        email,
        phone,
        isSample: false
      },
      existingContact: existingContact,
      refreshExistingContacts: fetchContacts,
      onValidation: setNewContactValid,
      onChange: change => {
        setIsSampleRelationship(change.type === 'sampleContact');
        setClientContactId(change.type === 'existingContact' ? change.id : null);
        if (change.type === 'existingContact') {
          setShowCustomerDetailsWarning(false);
        } else if (change.type === 'initial') {
          setFirstName('');
          setLastName('');
          setCompanyName('');
          setEmail('');
          setPhoneNumber('');
        }
      },
      isDraftOriginatedAsEdit: isDraftOriginatedAsEdit,
      showCustomerDetailsWarning: showCustomerDetailsWarning
    }), (MULTIPLE_RECEPIENTS && (relationshipDraft === null || relationshipDraft === void 0 ? void 0 : relationshipDraft.reviewers) && (relationshipDraft === null || relationshipDraft === void 0 ? void 0 : relationshipDraft.reviewers.length) > 0 || reviewers.length > 0) && /*#__PURE__*/React.createElement(GridItem, {
      span: 12
    }, /*#__PURE__*/React.createElement(SignatoryCheckbox, {
      info: /*#__PURE__*/React.createElement("div", {
        "data-testid": 'primary-contact-required-sign-checkbox-info-tooltip'
      }, "The primary contact must sign the proposal."),
      checkboxTestid: 'primary-contact-required-sign-checkbox',
      value: true,
      disabled: true,
      infoTestid: 'primary-contact-required-sign-checkbox-info'
    })), MULTIPLE_RECEPIENTS ? /*#__PURE__*/React.createElement(AddAdditionalRecipients, {
      primaryContact: existingContact,
      amendmentInfoCallout: amendmentInfoCallout,
      initialState: reviewers,
      showReviewerErrors: showReviewerErrors,
      onChange: setReviewers
    }) : amendmentInfoCallout && /*#__PURE__*/React.createElement(GridItem, {
      span: 12
    }, amendmentInfoCallout), /*#__PURE__*/React.createElement(DatePickerPanel, {
      value: effectiveDate,
      onChange: setEffectiveDate,
      title: "Agreement effective date",
      description: "The date when you can start providing the services and bill the client."
    })),
    inlineFooterActions: [{
      text: 'Save as template',
      intent: Intent.CreateProposalTemplate,
      testid: 'agreement-studio-save-template',
      disabled: draftId == null,
      onClick: saveAsTemplate,
      tooltipTitle: draftId == null ? 'Make changes to your draft in order to save it as a proposal template' : undefined
    }],
    additionalFooterActions: [{
      text: 'Discard draft',
      skin: 'error',
      disabled: draftId == null,
      iconStart: /*#__PURE__*/React.createElement(TrashLine, null),
      testid: 'agreement-studio-topbar-discard-draft',
      onClick: discardDraft
    }],
    submitButtonLabel: "Send",
    submitButtonIntent: Intent.SendProposal,
    onSubmitCb: onSubmit,
    onAutoSaveCb: saveDraft,
    openPreviewModal: openPreviewModal
  })) : /*#__PURE__*/React.createElement(FunctionalLoader, {
    show: true
  });
}